import { Tag } from "primereact/tag";
import { useGetCategoryQuery } from "../store/api/directory/categoryApi"
import { getStatus } from "./partial";
import { Calendar } from "primereact/calendar";
import { formatDateUTC } from "./user";


export const orderColumn = [
    {
        attr: "guid",
        labelKey: "guid",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "codeid",
        labelKey: "codeid",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "country",
        labelKey: "country",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "category",
        attr_en: "category_en",
        labelKey: "category",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "tracking_code",
        labelKey: "tracking_code",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "amount",
        labelKey: "amount",
        type: 2,
        opt: 2,
        hidden: false,
        editor: true
    },
    {
        attr: "currency_guid",
        labelKey: "currency_guid",
        type: 3,
        opt: 2,
        hidden: true,
        editor: true
    },
    {
        attr: "currency",
        labelKey: "currency",
        type: 3,
        opt: 2,
        hidden: false,
        editor: false
    },
    {
        attr: "client_code",
        labelKey: "client_code",
        type: 1,
        opt: 6,
        optionLabel: "email",
        optionValue: "guid",
        hidden: false,
        editor: false
    },
    {
        attr: "client",
        labelKey: "client",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "country_guid",
        labelKey: "country_guid",
        type: 3,
        opt: 5,
        optionLabel: "country",
        optionValue: "guid",
        hidden: true,
        editor: true
    },
    {
        attr: "reciever_guid",
        labelKey: "reciever_guid",
        type: 3,
        opt: 6,
        optionLabel: "email",
        optionValue: "guid",
        hidden: true,
        editor: false
    },
    {
        attr: "Коробку",
        labelKey: "Коробку",
        type: 1,
        hidden: false,
        editor: false,
        body: (rowData, trans) => {
            return <Tag value={rowData.with_box ? "Оставить" : "Убрать"} severity={(rowData.with_box ? "success" : "danger")} />;
        }
    },
    {
        attr: "tracking_number",
        labelKey: "tracking_number",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "gross_weight",
        labelKey: "gross_weight",
        type: 1,
        hidden: false,
        editor: true
    }, {
        attr: "shop",
        labelKey: "shop",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "category_guid",
        labelKey: "category_guid",
        type: 3,
        optionLabel: "name",
        optionValue: "guid",
        hidden: true,
        editor: true
    },
    {
        attr: "stock_comment",
        labelKey: "Комментарий склада",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "description",
        labelKey: "description",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "prefer_pickup",
        labelKey: "ПВЗ",
        type: 5,
        hidden: false,
        editor: false,
        body: (data) => {
            return <>
                {
                    data.pickup_name ?? data?.prefer_pickup ?? ""
                }
            </>
        }
    },
    {
        attr: "date_f",
        label: "date_create_order",
        type: 1,
        dateType: "date",
        hidden: false,
        editor: false,
        body: (rowData) =>
            rowData.date_f
                ? formatDateUTC(rowData.date_f)
                : ""
        ,
        filterTemplate: (options) => {
            return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999" />;
        }

    },
    {
        attr: "date_issue",
        label: "date_issue",
        type: 1,
        dateType: "date",
        hidden: false,
        editor: false,
        body: (rowData) =>
            rowData.date_f
                ? formatDateUTC(rowData.date_issue)
                : ""
        ,
        filterTemplate: (options) => {
            return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999" />;
        }

    },
    {
        attr: "invoice",
        labelKey: "invoice",
        type: 5,
        hidden: true,
        editor: true
    },
    {
        attr: "access_confirm",
        labelKey: "access_confirm",
        type: 1,
        hidden: false,
        editor: false,
        body: (rowData, trans) => {
            return <Tag value={trans(getStatus(rowData.status).text)} severity={getStatus(rowData.status).variant} />;
        }
    }, {
        attr: "invoice",
        labelKey: "invoice",
        type: 5,
        hidden: false,
        editor: false,
        body: (rowData) => {
            return <a href={"https://onza-api.ibm.kg/files/invoice/" + rowData.invoice_path} target="_blank" download>{rowData.invoice_path}</a>
        }
    }
]


export const orderProcColumn = [
    {
        attr: "guid",
        labelKey: "guid",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "codeid",
        labelKey: "codeid",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "country",
        labelKey: "country",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "client",
        labelKey: "client",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "Коробку",
        labelKey: "Коробку",
        type: 1,
        hidden: false,
        editor: true,
        body: (rowData, trans) => {
            return <Tag value={rowData.with_box ? "Оставить" : "Убрать"} severity={(rowData.with_box ? "success" : "danger")} />;
        }
    },
    {
        attr: "tracking_number",
        labelKey: "tracking_number",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "date_f",
        label: "date_create_order",
        type: 1,
        dateType: "date",
        hidden: false,
        editor: false,
        body: (rowData) =>
            rowData.date_f
                ? formatDateUTC(rowData.date_f)
                : ""
        ,
        filterTemplate: (options) => {
            return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999" />;
        }

    },
    {
        attr: "access_confirm",
        labelKey: "access_confirm",
        type: 1,
        hidden: false,
        editor: false,
        body: (rowData, trans) => {
            return <Tag value={trans(getStatus(rowData.status).text)} severity={getStatus(rowData.status).variant} />;
        }
    }
]


export const orderPartialColumn = [
    {
        attr: "guid",
        labelKey: "guid",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "codeid",
        labelKey: "codeid",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "country",
        labelKey: "country",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "category",
        labelKey: "category",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "amount",
        labelKey: "amount",
        type: 2,
        opt: 2,
        hidden: false,
        editor: true
    },
    {
        attr: "client",
        labelKey: "client",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "tracking_number",
        labelKey: "tracking_number",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "tracking_code",
        labelKey: "tracking_code",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "category_guid",
        labelKey: "category_guid",
        type: 3,
        optionLabel: "name",
        optionValue: "guid",
        hidden: true,
        editor: true
    },
    {
        attr: "description",
        labelKey: "description",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "created_date",
        labelKey: "date_create_order",
        type: 1,
        hidden: false,
        editor: false,
        body: (rowData) =>
            rowData.date_f
                ? formatDateUTC(rowData.date_f)
                : ""
        ,
        filterTemplate: (options) => {
            return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999" />;
        }
    },
    {
        attr: "date_accept",
        labelKey: "date_accept",
        type: 1,
        hidden: false,
        editor: false,
        body: (rowData) =>
            rowData.date_accept
                ? formatDateUTC(rowData.date_accept)
                : ""
        ,
        filterTemplate: (options) => {
            return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999" />;
        }
    },
    {
        attr: "invoice",
        labelKey: "invoice",
        type: 5,
        hidden: true,
        editor: true
    },
    {
        attr: "status",
        labelKey: "status",
        type: 1,
        hidden: false,
        editor: true,
        body: (rowData, trans) => {
            return <Tag value={trans(getStatus(rowData.status).text)} severity={getStatus(rowData.status).variant} />;
        }
    }, {
        attr: "invoice",
        labelKey: "invoice",
        type: 5,
        hidden: false,
        editor: false,
        body: (rowData) => {
            return <a href={"https://onza-api.ibm.kg/files/invoice/" + rowData.invoice_path} target="_blank" download>{rowData.invoice_path}</a>
        }
    },
]


export const orderColumnDetail = [
    {
        attr: "codeid",
        labelKey: "codeid",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "country",
        labelKey: "country",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "category",
        attr_en: "category_en",
        labelKey: "category",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "box_code",
        labelKey: "tracking_code",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "amount",
        labelKey: "amount",
        type: 2,
        opt: 2,
        hidden: false,
        editor: true
    },
    {
        attr: "currency_guid",
        labelKey: "currency_guid",
        type: 3,
        opt: 2,
        hidden: true,
        editor: true
    },
    {
        attr: "currency",
        labelKey: "currency",
        type: 3,
        opt: 2,
        hidden: false,
        editor: false
    },
    {
        attr: "country_guid",
        labelKey: "country_guid",
        type: 3,
        opt: 5,
        optionLabel: "country",
        optionValue: "guid",
        hidden: true,
        editor: true
    },
    {
        attr: "reciever_guid",
        labelKey: "reciever_guid",
        type: 3,
        opt: 6,
        optionLabel: "email",
        optionValue: "guid",
        hidden: true,
        editor: false
    },
    {
        attr: "Коробку",
        labelKey: "Коробку",
        type: 1,
        hidden: false,
        editor: false,
        body: (rowData, trans) => {
            return <Tag value={rowData.with_box ? "Оставить" : "Убрать"} severity={(rowData.with_box ? "success" : "danger")} />;
        }
    },
    {
        attr: "tracking_number",
        labelKey: "tracking_number",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "shop",
        labelKey: "shop",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "gross_weight",
        labelKey: "gross_weight",
        type: 1,
        hidden: false,
        editor: true,
        body: (item) => {
            return Number(parseFloat(item.gross_weight) || 0).toFixed(2) ?? ''
        }
    },
    {
        attr: "category_guid",
        labelKey: "category_guid",
        type: 3,
        optionLabel: "name",
        optionValue: "guid",
        hidden: true,
        editor: true
    },
    {
        attr: "description",
        labelKey: "description",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "date_f",
        label: "date_create_order",
        type: 1,
        dateType: "date",
        hidden: false,
        editor: false,
        body: (rowData) =>
            rowData.date_f
                ? formatDateUTC(rowData.date_f)
                : ""
        ,
        filterTemplate: (options) => {
            return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999" />;
        }

    },
    {
        attr: "date_accept",
        label: "Дата принятия на зарубежный склад",
        type: 1,
        dateType: "date",
        hidden: false,
        editor: false,
        body: (rowData) =>
            rowData.date_accept
                ? formatDateUTC(rowData.date_accept)
                : ""
        ,
        filterTemplate: (options) => {
            return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999" />;
        }

    },
    {
        attr: "date_transfer",
        label: "Дата отправки",
        type: 1,
        dateType: "date",
        hidden: false,
        editor: false,
        body: (rowData) =>
            rowData.date_transfer
                ? formatDateUTC(rowData.date_transfer)
                : ""
        ,
        filterTemplate: (options) => {
            return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999" />;
        }

    },
    {
        attr: "date_main_scan",
        label: "Дата принятия на основной склад",
        type: 1,
        dateType: "date",
        hidden: false,
        editor: false,
        body: (rowData) =>
            rowData.date_main_scan
                ? formatDateUTC(rowData.date_main_scan)
                : ""
        ,
        filterTemplate: (options) => {
            return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999" />;
        }

    },

    {
        attr: "date_issue",
        label: "Дата выдачи",
        type: 1,
        dateType: "date",
        hidden: false,
        editor: false,
        body: (rowData) =>
            rowData.date_issue
                ? formatDateUTC(rowData.date_issue)
                : ""
        ,
        filterTemplate: (options) => {
            return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999" />;
        }

    },


    {
        attr: "invoice",
        labelKey: "invoice",
        type: 5,
        hidden: false,
        editor: false,
        body: (rowData) => {
            return <a href={"https://onza-api.ibm.kg/files/invoice/" + rowData.invoice_path} download>{rowData.invoice_path}</a>
        }
    },
    {
        attr: "status",
        labelKey: "access_confirm",
        type: 3,
        opt: 11,
        optionLabel: "status_name",
        optionValue: "codeid",
        hidden: false,
        editor: true,
        body: (rowData, trans) => {
            return <Tag value={trans(getStatus(rowData.status).text)} severity={getStatus(rowData.status).variant} />;
        }
    }, {
        attr: "pickup_name",
        labelKey: "ПВЗ",
        type: 5,
        hidden: false,
        editor: false,
        body: (data) => {
            return <>
                {
                    data.pickup_name ?? data?.prefer_pickup ?? ""
                }
            </>
        }
    }
]


export const orderColumnSort = [
    {
        attr: "codeid",
        labelKey: "codeid",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "payment_status",
        labelKey: "Оплата",
        type: 1,
        hidden: false,
        editor: false,
        body: (rowData, trans) => {
            if (rowData.current_payment_status == 2) return <Tag value="Оплачено" severity="success" />;
            else return <Tag value={rowData.payment_status ? "Оплачено" : "Не полачено"} severity={(rowData.payment_status ? "success" : "danger")} />;
        }
    },
    {
        attr: "price",
        attr_en: "category_en",
        label: "Стоимость доставки",
        type: 1,
        hidden: false,
        editor: false,
        body: (data) => {
            if (data.shipping_cost) {
                return data.shipping_cost;
            }
            let rate = 0
            if (data.country_guid === "9B785514-12A9-4336-A927-C36A46596D3D") {
                rate = 999;
            } else if (data.country_guid === "A4D9A734-CCEC-49AF-A5B5-6D5765639D21") {
                rate = 1100;
            }
            const weight = Math.ceil((data.gross_weight ?? 0) * 10) / 10; // ⬅️ округляем вверх до 0.1 кг

            return (data?.shipping_cost && data.shipping_cost > 0) ? Number(data.shipping_cost) : weight * rate;
        }
    },
    {
        attr: "country",
        labelKey: "country",
        type: 1,
        hidden: false,
        editor: false
    }, {
        attr: "country_guid",
        labelKey: "country_guid",
        type: 3,
        opt: 5,
        optionLabel: "country",
        optionValue: "guid",
        hidden: true,
        editor: true
    }, {
        attr: "category",
        attr_en: "category_en",
        labelKey: "category",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "box_code",
        labelKey: "tracking_code",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "Коробку",
        labelKey: "Коробку",
        type: 1,
        hidden: false,
        editor: false,
        body: (rowData, trans) => {
            return <Tag value={rowData.with_box ? "Оставить" : "Убрать"} severity={(rowData.with_box ? "success" : "danger")} />;
        }
    },
    {
        attr: "tracking_number",
        labelKey: "tracking_number",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "shop",
        labelKey: "shop",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "gross_weight",
        labelKey: "gross_weight",
        type: 1,
        hidden: false,
        editor: true,
        body: (item) => {
            return Number(parseFloat(item.gross_weight) || 0).toFixed(2) ?? ''
        }
    }, {
        attr: "width",
        labelKey: "width",
        type: 1,
        hidden: false,
        editor: true
    }, {
        attr: "height",
        labelKey: "height",
        type: 1,
        hidden: false,
        editor: true
    }, {
        attr: "length",
        labelKey: "length",
        type: 1,
        hidden: false,
        editor: true
    }, {
        attr: "shipping_cost",
        labelKey: "shipping_cost",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "category_guid",
        labelKey: "category_guid",
        type: 3,
        optionLabel: "name",
        optionValue: "guid",
        hidden: true,
        editor: true
    },
    {
        attr: "address_delivery",
        label: "Адрес доставки",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "client",
        labelKey: "client",
        type: 1,
        hidden: false,
        editor: false
    }, {
        attr: "description",
        labelKey: "description",
        type: 1,
        hidden: false,
        editor: true,
        maxWidth: "300px"
    },
    {
        attr: "date_f",
        label: "date_create_order",
        type: 1,
        dateType: "date",
        hidden: false,
        editor: false,
        body: (rowData) =>
            rowData.date_f
                ? formatDateUTC(rowData.date_f)
                : ""
        ,
        filterTemplate: (options) => {
            return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999" />;
        }

    },
    {
        attr: "pickup_name",
        labelKey: "ПВЗ",
        type: 5,
        hidden: false,
        editor: false,
        body: (data) => {
            return <>
                {
                    data.pickup_name ?? data?.prefer_pickup ?? ""
                }
            </>
        }
    },
    {
        attr: "pickup_guid",
        labelKey: "Выбрать ПВЗ",
        type: 3,
        opt: 12,
        hidden: true,
        editor: true
    },
    {
        attr: "status",
        labelKey: "access_confirm",
        type: 3,
        opt: 11,
        optionLabel: "status_name",
        optionValue: "codeid",
        hidden: false,
        editor: false,
        body: (rowData, trans) => {
            return <Tag value={trans(getStatus(rowData.status).text)} severity={getStatus(rowData.status).variant} />;
        }
    }
]


export const orderColumnIssue = [
    {
        attr: "codeid",
        labelKey: "codeid",
        type: 1,
        hidden: true,
        editor: false
    }, {
        attr: "payment_status",
        labelKey: "Оплата",
        type: 1,
        hidden: false,
        editor: false,
        body: (rowData, trans) => {
            if (rowData.current_payment_status == 2) return <Tag value="Оплачено" severity="success" />;
            else return <Tag value={rowData.payment_status ? "Оплачено" : "Не оплачено"} severity={(rowData.payment_status ? "success" : "danger")} />;
        }
    },
    {
        attr: "country",
        labelKey: "country",
        type: 1,
        hidden: false,
        editor: false
    }, {
        attr: "category",
        attr_en: "category_en",
        labelKey: "category",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "price",
        attr_en: "category_en",
        label: "Стоимость доставки",
        type: 1,
        hidden: false,
        editor: false,
        body: (data) => {
            let rate = 0
            if (data.country_guid === "9B785514-12A9-4336-A927-C36A46596D3D") {
                rate = 999;
            } else if (data.country_guid === "A4D9A734-CCEC-49AF-A5B5-6D5765639D21") {
                rate = 1100;
            }
            const weight = Math.ceil((data.gross_weight ?? 0) * 10) / 10; // ⬅️ округляем вверх до 0.1 кг

            return (data?.shipping_cost && data.shipping_cost > 0) ? Number(data.shipping_cost) : weight * rate;
        }
    },

    {
        attr: "tracking_number",
        labelKey: "tracking_number",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "gross_weight",
        labelKey: "gross_weight",
        type: 1,
        hidden: false,
        editor: true,
        body: (item) => {
            return Number(parseFloat(item.gross_weight) || 0).toFixed(2) ?? ''
        }
    },
    {
        attr: "client",
        labelKey: "client",
        type: 1,
        hidden: false,
        editor: false
    }, {
        attr: "client_code",
        labelKey: "client_code",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "updated_at",
        label: "Дата принятия на ПВЗ",
        type: 1,
        dateType: "date",
        hidden: false,
        editor: false,
        body: (rowData) =>
            rowData.updated_at
                ? formatDateUTC(rowData.updated_at)
                : ""
        ,
        filterTemplate: (options) => {
            return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999" />;
        }

    },

    {
        attr: "pickup_name",
        label: "ПВЗ",
        type: 5,
        hidden: false,
        editor: false,
        body: (data) => {
            return <>
                {
                    data.pickup_name ?? data?.prefer_pickup ?? ""
                }
            </>
        }
    },
    {
        attr: "address_delivery",
        labelKey: "Адрес доставки",
        type: 3,
        opt: 12,
        hidden: false,
        editor: true
    }
]

export const orderColumnAcceptPVZ = [
    {
        attr: "codeid",
        labelKey: "codeid",
        type: 1,
        hidden: true,
        editor: false
    }, {
        attr: "payment_status",
        label: "Оплата",
        type: 1,
        hidden: false,
        editor: false,
        body: (rowData, trans) => {
            if (rowData.current_payment_status == 2) return <Tag value="Оплачено" severity="success" />;
            else return <Tag value={rowData.payment_status ? "Оплачено" : "Не полачено"} severity={(rowData.payment_status ? "success" : "danger")} />;
        }
    },
    {
        attr: "country",
        labelKey: "country",
        type: 1,
        hidden: false,
        editor: false
    }, {
        attr: "category",
        attr_en: "category_en",
        labelKey: "category",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "price",
        attr_en: "category_en",
        label: "Стоимость доставки",
        type: 1,
        hidden: false,
        editor: false,
        body: (data) => {
            let rate = 0
            if (data.country_guid === "9B785514-12A9-4336-A927-C36A46596D3D") {
                rate = 999;
            } else if (data.country_guid === "A4D9A734-CCEC-49AF-A5B5-6D5765639D21") {
                rate = 1100;
            }
            const weight = Math.ceil((data.gross_weight ?? 0) * 10) / 10; // ⬅️ округляем вверх до 0.1 кг

            return (data?.shipping_cost && data.shipping_cost > 0) ? Number(data.shipping_cost) : weight * rate;
        }
    },

    {
        attr: "tracking_number",
        labelKey: "tracking_number",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "gross_weight",
        labelKey: "gross_weight",
        type: 1,
        hidden: false,
        editor: true,
        body: (item) => {
            return Number(parseFloat(item.gross_weight) || 0).toFixed(2) ?? ''
        }
    },
    {
        attr: "client",
        labelKey: "client",
        type: 1,
        hidden: false,
        editor: false
    }, {
        attr: "client_code",
        labelKey: "client_code",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "date_accept",
        label: "Дата принятия на ПВЗ",
        type: 1,
        dateType: "date",
        hidden: false,
        editor: false,
        body: (rowData) =>
            rowData.date_accept
                ? formatDateUTC(rowData.date_accept)
                : ""
        ,
        filterTemplate: (options) => {
            return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999" />;
        }

    },
    {
        attr: "pickup_name",
        label: "ПВЗ",
        type: 5,
        hidden: false,
        editor: false,
        body: (data) => {
            return <>
                {
                    data.pickup_name
                }
            </>
        }
    },
    {
        attr: "address_delivery",
        label: "Адрес доставки",
        type: 3,
        opt: 12,
        hidden: false,
        editor: true
    }
]


export const orderColumnDelivery = [
    {
        attr: "codeid",
        labelKey: "codeid",
        type: 1,
        hidden: true,
        editor: false
    }, {
        attr: "payment_status",
        labelKey: "Оплата",
        type: 1,
        hidden: false,
        editor: false,
        body: (rowData, trans) => {
            if (rowData.current_payment_status == 2) return <Tag value="Оплачено" severity="success" />;
            else return <Tag value={rowData.payment_status ? "Оплачено" : "Не полачено"} severity={(rowData.payment_status ? "success" : "danger")} />;
        }
    },
    {
        attr: "country",
        labelKey: "country",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "price",
        attr_en: "category_en",
        label: "Стоимость доставки",
        type: 1,
        hidden: false,
        editor: false,
        body: (data) => {
            let rate = 0
            if (data.country_guid === "9B785514-12A9-4336-A927-C36A46596D3D") {
                rate = 999;
            } else if (data.country_guid === "A4D9A734-CCEC-49AF-A5B5-6D5765639D21") {
                rate = 1100;
            }
            const weight = Math.ceil((data.gross_weight ?? 0) * 10) / 10; // ⬅️ округляем вверх до 0.1 кг

            return (data?.shipping_cost && data.shipping_cost > 0) ? Number(data.shipping_cost) : weight * rate;
        }
    },

    {
        attr: "tracking_number",
        labelKey: "tracking_number",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "gross_weight",
        labelKey: "gross_weight",
        type: 1,
        hidden: false,
        editor: true,
        body: (item) => {
            return Number(parseFloat(item.gross_weight) || 0).toFixed(2) ?? ''
        }
    },
    {
        attr: "client",
        labelKey: "client",
        type: 1,
        hidden: false,
        editor: false
    }, {
        attr: "client_code",
        labelKey: "client_code",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "address_delivery",
        labelKey: "Адрес доставки",
        type: 3,
        opt: 12,
        hidden: false,
        editor: true
    }
]